import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-registration-unsuccess',
  templateUrl: './registration-unsuccess.component.html',
  styleUrls: ['./registration-unsuccess.component.scss']
})
export class RegistrationUnsuccessComponent implements OnInit {
  errMsg = '';
  resumeLink = '/';

  constructor(private route: ActivatedRoute, private router: Router) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.errMsg = params['errMsg'] || '發生錯誤，請稍後重試。';
      const queryParams: string[] = [];
      ['last_name', 'first_name', 'email', 'phone', 'affiliation', 'agree_marketing'].forEach(field => {
        if (params[field]) {
          queryParams.push(`${field}=${encodeURIComponent(params[field])}`);
        }
      });
      this.resumeLink = queryParams.length ? `/?${queryParams.join('&')}` : '/';
    });
  }
}
